import { SIGN_IN_URL, TOKEN_URL } from '../../util/urls';
import { registerUser } from '../../api/api';
import {
  AUTH_USER,
  UNAUTH_USER,
  REMOVE_USER,
  OPEN_SIGN_POPUP,
  REGISTERED_USER,
  CLOSE_SIGN_POPUP,
  GUEST_USER,
  UPDATE_USER_DETAILS,
  AUTH_USER_FAILED,
  UPDATE_MEAL_PLAN,
  UPDATE_GUEST_USER,
  REMOVE_GUEST_USEER,
  AUTH_GUEST
} from '../constants/actionTypes';
import Logger from '../../util/Logger';

const SUCCESS_STATUS = 'S';
const FAILED_STATUS = 'F';
const LOGIN_SUCCESS = 'ok';

//Actions
export function loginUser(type) {
  return function(dispatch) {
    if (type === AUTH_USER) {
      dispatch({
        type: AUTH_USER,
      });
    } else {
      dispatch({
        type: UNAUTH_USER,
      });
    }
  };
}

export function logoutUser(error) {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: UNAUTH_USER,
        payload: error || '',
        tokenId: false,
        jwt: '',
      });
      deleteCookie('token');
      resolve();
    });
  };
}

export function removeUser() {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: REMOVE_USER,
      });
      resolve();
    });
  };
}

export function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function openSignInPopUp(signInCaller) {
  return {
    type: OPEN_SIGN_POPUP,
    signInCaller: signInCaller || false,
  };
}

export function closeSignInPopUp() {
  return {
    type: CLOSE_SIGN_POPUP,
  };
}

export function loginUserRequest(object) {
  let languageid = localStorage.getItem('language') ? localStorage.getItem('language') : '1';
  return dispatch => {
    // signInOldBackend will be removed after all PHP backend is moved to the new backend
    return Promise.all( [ 
        signInOldBackend(object), 
        signInNewBackend(object.signinname, object.password, localStorage.getItem('lavutoGoName')) 
      ] )
      .then(fullLogin => {
        // loginUserResponse will receive only newLogin parameter after all PHP backend is moved to the new backend
        return dispatch(loginUserResponse(
          fullLogin[0],
          fullLogin[1]
        ));
      })
      .catch((error) => {
        return dispatch(authenticationFailed(error.message));
      });
  };
}

const signInNewBackend = (username, password, locationName) => { 
  return new Promise(async (resolve, reject) => {
      fetch(`${process.env.REACT_APP_API_URL}/signin_customer`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username,
          password,
          locationName,
        }),
      })
      .then(res => (res ? res.json() : {}))
      .then(login => {
        resolve(login);
      })
      .catch(error => {
        return reject(error);
      });
  })
};

//-----------------------------------------------------------------------------------------
// This will be deprecated and removed after all PHP backend is moved to the new backend
//-----------------------------------------------------------------------------------------
const signInOldBackend = (object) => { 
  let languageid = localStorage.getItem('language') ? localStorage.getItem('language') : '1';
  return new Promise(async (resolve, reject) => {
    fetch(SIGN_IN_URL + 'tokenId/' + object.tokenId, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + btoa(object.jwt),
      },
      body: JSON.stringify({
        dataname: object.dataname,
        email: object.signinname,
        password: object.password,
        languageid: languageid,
      }),
    })
      .then(res => (res ? res.json() : {}))
      .then(login => {
        resolve(login.DataResponse);
      })
      .catch(error => {
        return reject(error);
      });
  })
};

//-----------------------------------------------------------------------------------------
// oldLogin parameter have to be removed after all PHP backend is moved to the new backend,
// and use only newLogin data
//-----------------------------------------------------------------------------------------
export function loginUserResponse(oldLogin, newLogin) {
  if ( oldLogin.Status === SUCCESS_STATUS && 
       newLogin.message === LOGIN_SUCCESS ) {
         let date = new Date();
         date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
         let expires = '; expires=' + date.toGMTString();
         document.cookie = 'token=' + oldLogin.tokenId + expires;
        return authenticationSuccessful({ 
          userData: newLogin.user,
          tokenId: oldLogin.tokenId,
          jwt: oldLogin.jwt,
          customerToken: newLogin.token,
        });
    } else
      return authenticationFailed(oldLogin.Status !== SUCCESS_STATUS ? oldLogin.msg : newLogin.message);
}

export const authenticationSuccessful = (loginData) => ({
  type: AUTH_USER,
  status: SUCCESS_STATUS,
  message: "Login Successful",
  tokenId: loginData.tokenId,
  jwt: loginData.jwt,
  userData: loginData.userData,
  // New Login data
  customerToken: loginData.customerToken,
 });

export const authenticationFailed = (message) => ({
  type: AUTH_USER_FAILED,
  status: FAILED_STATUS,
  message,
  tokenId: '',
  jwt: '',
});

export const updateMealPlan = mealPlan => ({
  type: UPDATE_MEAL_PLAN,
  payload: mealPlan,
});

export const updateGuestUser = guestUser => ({
  type: UPDATE_GUEST_USER,
  payload: guestUser,
});

export function removeGuestUser() {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: REMOVE_GUEST_USEER,
      });
      resolve();
    });
  };
}

export function registerUserRequest({
  email,
  password,
  fname,
  lname,
  mobile,
  cpwd,
  name,
  address_1,
  address_2,
  country,
  state,
  city,
  zipcode,
  is_primary,
  jwt,
  tokenId,
}) {
  return dispatch => {
    return registerUser({
      email,
      password,
      fname,
      lname,
      mobile,
      cpwd,
      name,
      address_1,
      address_2,
      country,
      state,
      city,
      zipcode,
      is_primary,
      jwt,
      tokenId,
    }).then(apiResponse => {
      return dispatch(registerUserResponse(apiResponse.data.DataResponse));
    });
  };
}

export function registerUserResponse(res) {
  return {
    type: REGISTERED_USER,
    status: res.Status,
    message: res.msg,
  };
}

export function guestUser() {
  return {
    type: GUEST_USER,
  };
}

export function updateUserDetails(data) {
  return {
    type: UPDATE_USER_DETAILS,
    data: data,
  };
}

export function loginGuestRequest(lavuToGoName) {
  return dispatch => {
    // signInOldBackendGuest will be removed after all PHP backend is moved to the new backend
    return Promise.all( [ 
      signInGuest(lavuToGoName), 
      signInOldBackendGuest() 
    ] ).then(fullGuestLogin => {
      // guestAuthenticationSuccessful will receive only guestLogin parameter after all PHP backend is moved to the new backend
      const result = {
        guestLogin: fullGuestLogin[0],
        phpGuestLogin: fullGuestLogin[1],
      };
      return dispatch(guestAuthenticationSuccessful(
        result.guestLogin.token, 
        result.phpGuestLogin.tokenId, 
        result.phpGuestLogin.jwt,
        result.guestLogin.restaurantLocation
      ));
    })
    .catch((error) => {
      Logger.log(error);
      throw error;
    });
  };
}

export const signInGuest = (locationName) => { 
  return new Promise(async (resolve, reject) => {
      fetch(`${process.env.REACT_APP_API_URL}/signin_location_guest`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          locationName,
        }),
      })
      .then(res => (res ? res.json() : {}))
      .then(login => {
        resolve(login);
      })
      .catch(error => {
        return reject(error);
      });
  })
};

//-----------------------------------------------------------------------------------------
// This will be deprecated and removed after all PHP backend is moved to the new backend
//-----------------------------------------------------------------------------------------
export const signInOldBackendGuest = () => { 
  return new Promise(async (resolve, reject) => {
    fetch(TOKEN_URL, {
      method: 'POST',
      body: JSON.stringify({
        name: '!LaVu116!',
        prod: 'olo',
      }),
    })
    .then(res => (res ? res.json() : {}))
    .then(login => {
      if (!login || login.status === 500)
        return reject(new Error('Failed getting PHP Guest Token'));
      resolve(login);
    })
    .catch(error => {
      return reject(error);
    });
  })
};

export const guestAuthenticationSuccessful = (guestToken, phpTokenId, phpJWT, restaurantLocation) => ({
  type: AUTH_GUEST,
  guestToken: guestToken,
  tokenId: phpTokenId,
  jwt: phpJWT,
  restaurantLocation: restaurantLocation,
 });


// WEBPACK FOOTER //
// ./src/redux/actions/authenticationActions.js